var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../framework/Framework';
import { Component } from '../framework/Component';
export class AnchorScrollComponent extends Component {
    constructor() {
        super('AnchorScrollComponent', true);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if (location.hash.length > 2) {
                const headerHeight = (window.innerWidth < 991) ? $('header').get(0).getBoundingClientRect().height : 0;
                const top = $(location.hash).get(0).getBoundingClientRect().top + window.scrollY;
                $.scrollTo(top - headerHeight);
            }
            this.success();
        });
    }
}
